export var IconAppearance;
(function (IconAppearance) {
    IconAppearance["SOCIAL_ICON"] = "social-icon";
    IconAppearance["GREY_ICON"] = "grey-icon";
    IconAppearance["UNREAD_ICON"] = "unread-icon";
})(IconAppearance || (IconAppearance = {}));
export var IconColor;
(function (IconColor) {
    IconColor["RED"] = "color-red";
})(IconColor || (IconColor = {}));
//# sourceMappingURL=oh-icon.types.js.map
